<template>
	<div class="mb-4">
		<v-row>
			<v-col cols="6" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar 
						label="1.- Información Recepción"
						color="#E0F7F2"
					></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{"Peso Guía"}}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.RcfWeightGuide | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{"Peso Neto"}}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.WbbNetWeight | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{"Peso Actualizado"}}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.WbbNetWeight | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="6" class="s-col-form">
				<!--  -->
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar 
						label="2.- Tolerancia Descarte Seleccion"
						color="#E0F7F2"
					></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{"Tolerancia aceptada"}}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<s-text
									v-model="AcceptedToleranceInputDiscart"
									decimal
								
								/> 
<!-- :readonly="lotReception.RcfStatusSap == 2" -->
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiDisSelToleranceAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{"Descarte no aceptada"}}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 style="color : red">
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage | numberDefault }}%
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate | numberDefaultKg }}
								</h4>
								<v-checkbox
									v-model="lotReception.RfsDiscardNotAceppted"
									:label="labelCheckBox2"
									 @change="onCheckboxChange2"
								></v-checkbox>
							</v-col>
							
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="6" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar 
						label="3.- Descuentos totales"
						color="#E0F7F2"
					></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{"Descarte no aceptada"}}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 style="color : red">
									{{ lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAcceptedPercentage | numberDefault }}%
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{"Peso a pagar"}}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisTotWeightPay | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 style="color : red">
									{{ lotReception.DisTotWeightPayPercentage | numberDefault }}%
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="6" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar 
						label="4.- Distribución Almacenes"
						color="#E0F7F2"
					></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form" cols="4">
								<h4>
									{{"Peso Final aceptable"}}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<h4>
									{{ finalweightacceptable | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="success--text font-weight-black">
									{{"Alm. 02"}}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="4">
								<h4>
									{{"Merma aceptable"}}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<h4>
									{{ lotReception.RfsWeightDiscart | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<h4 class="red--text font-weight-black">
									{{"Alm. 20"}}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<s-text 
									v-model="AcceptedDiscartMaq" 
									decimal
									:max="100"									
								/>							
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="4">
								<h4>
									{{ "Merma aceptable Maquila" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<h4>
									{{ lotReception.RfsWeightDiscartMaq | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<h4 class="warning--text font-weight-black">
									{{ "Alm. 33" }}
								</h4>
								<!-- <h4 class="info--text font-weight-black">
									{{ "Merma Aceptable Maquila " + lotReception.PorceDiscartoMaq + "%" }} 
								</h4> -->
							</v-col>
							<v-col class="s-col-form" cols="3">
								<s-select-definition
									v-model="lotReception.TypeSupplierMaq"
									:def="1689"
									label="Tipo Proveedor Maq."
									clearable
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="4">
								<h4>
									{{ "Merma Excedente Maquila" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<h4>
									{{ lotReception.RfsWeightDiscardNotAcepptedMaq | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<h4 class="warning--text font-weight-black">
									{{ "Alm. 33" }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="4">
								<h4>
									{{ "Peso de bolillo" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<h4>
									{{ lotReception.RfsWeightBolilloc | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<h4 class="info--text font-weight-black">
									{{ "Bolillo" }} 
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<s-text 
									v-model="AcceptedBolilloMaq" 
									decimal
									:max="100"
									
								/>							
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="4">
								<h4>
									{{ "Peso de bolillo Maquila" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<h4>
									{{ lotReception.RfsWeightBolilloMaq | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<h4 class="warning--text font-weight-black">
									{{ "Alm. 33" }}
								</h4>
								<!-- <h4 class="info--text font-weight-black">
									{{ "Bolillo Maquila " + lotReception.PorceBolilloMaq + "%" }} 
								</h4> -->
							</v-col>
							
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="4">
								<h4>
									{{ "Peso de Devolucion" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<h4>
									{{ lotReception.RfsWeightDevolution | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="info--text font-weight-black">
									{{ "Devolucion" }} 
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="4" >
								<h4>
									{{ "Peso de Devolucion por Pagar" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="3">
								<h4>
									<!-- {{ lotReception.RfsWeightDevolutionByPay | numberDefaultKg }} -->
									{{ calculateTotalKgNoAceptable() | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="info--text font-weight-black">
									{{ "Devolucion por Pagar" }} 
									<v-checkbox
									v-model="lotReception.RfsDevolutionByPay"
									:label="labelCheckBox"
									 @change="onCheckboxChange"
								></v-checkbox>
								</h4>
								
							</v-col>
							
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
        <v-row>
                    <v-col cols="12" class="s-col-form">
                        <v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
                            <s-toolbar label="CALIBRES" color="#E0F7F2"  :remove="removedCaliber" @removed="removeCalibers()" ></s-toolbar> 
                            <v-card-text>
                                <v-row v-if="itemsCaliber.length==0">
                                    <v-col class="s-col-form">
                                        <h4>
                                            {{ "No hay Categorias de Pagos para la fecha actual" }}
                                        </h4>
                                    </v-col>                                   
                                </v-row>
                                
                                <v-row v-if="itemsCaliber.length>0">
									<v-col class="pt-5 pr-0">
										<!-- <v-row v-for="d in  Object.keys(newGroups[item]) " > -->
										<v-row v-for="item in Object.keys(newGroups)" :key="item">
											<v-col cols="12" lg="8"
											class="pb-0 pt-1 pr-0 pl-0">
											<v-chip 
												small 
												:color = getColor(newGroups[item])
												> {{ item }}</v-chip>
										<!-- <v-chip v-if="viewPrices"
											small >
											{{ getPrice(newGroups[item][d]) }}
										</v-chip> -->
										
											<v-row v-for="(j, i) in newGroups[item]"  :key="i">									
												<v-col cols="2" lg="2" md="2">                                                   
													<s-text :label="j.TypeCaliberName"
														decimal
														:value="j.RfcQuantityKg == null ? 0.00 : j.RfcQuantityKg.toFixed(2)"
														:min="0"
														readonly
												
													></s-text>
													</v-col>
												<v-col cols="2" lg="2" md="2">                                                   
													<s-text :label="'Porcentaje'"
														decimal
														:value="j.RfcPercentage == null ? 0.00 : j.RfcPercentage"
														:min="0"
														readonly
														:suffix = "'%'"	
														disabled														
														></s-text>
													</v-col>
												<!-- Porcentaje Aceptable -->
												<v-col cols="2" lg="2" md="2">
													<s-text
													label="% Aceptable"
													decimal										
													v-model="acceptablePercentages[j.DctgID]"
													:value="j.RfcPercentage"
													:readonly="j.RfcPercentage == 0"
													suffix="%"
													@input="updateNoAceptable(j)"
													/>
												</v-col>
												<v-col cols="2" lg="2" md="2">
													<s-text
													label="Aceptable en Kg."
													decimal
													:value="j.RfcQuantityAcceptableKg == null ? 0.00 : j.RfcQuantityAcceptableKg"
													readonly
													suffix="Kg."
													disabled
													/>
												</v-col>

												<!-- Porcentaje No Aceptable (calculado) -->
												<v-col cols="2" lg="2" md="2">
													<s-text
													label="% No Aceptable"
													decimal
													:value="getUnacceptablePercentage(j)"
													readonly
													suffix="%"
													disabled
													/>
												</v-col>
												<!-- No Aceptable en Kg(calculado) -->
												<v-col cols="2" lg="2" md="2">
													<s-text
													label="No Aceptable en Kg."
													decimal
													:value="getUnacceptableKg(j)"
													readonly
													suffix="Kg."
													disabled
													/>
												</v-col>
											</v-row>
										
											</v-col>
										</v-row>
									</v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
	</div>
</template>

<script>
import _sReceptionFrozenService from '@/services/FrozenProduction/ReceptionFrozenService.js';
	export default {
		props: {
			lotReception: { }
		},

		data() {
			return {
				// lotReception: {},
				AcceptedToleranceInput : 0,
				AcceptedToleranceInputDiscart : 0,
				AcceptedBolilloMaq : 0,
				AcceptedDiscartMaq : 0,
                newGroups:[],
                listItemsCalibers: [],
                itemsCaliber: [],
                loadPrice: [],
				labelCheckBox:"No",
				labelCheckBox2:"No",
				checkboxByPay: 0,
				porcentageDecimal: 0,
				acceptablePercentages: {}, // clave: índice o ID, valor: aceptable
				RfsWeigthLocal : 1,
				removedCaliber:false
			}
		},

		watch: {
			AcceptedToleranceInput()
			{
				this.getCalcule();
			},

			AcceptedToleranceInputDiscart()
			{
				this.getCalcule();
			},
			'lotReception.RfsDevolutionByPay'(){
				this.labelCheckBox= this.lotReception.RfsDevolutionByPay ? "Si" : "No";
			},
			AcceptedBolilloMaq(){
				this.getCaluleBolilloMaq();
			},
			AcceptedDiscartMaq(){
				this.getCaluleDiscartMaq();
			},
			'lotReception.RfsDiscardNotAceppted'(){
				this.labelCheckBox2 = this.lotReception.RfsDiscardNotAceppted ? "Si" : "No";
				this.calculateDiscartNotAcepptedMaq();
			}
		},

		methods: {
			removeCalibers(){
				this.itemsCaliber.map((i) => {
					i.SecStatus=0
				});
				this.$fun.alert("¿Está seguro de elimar los calibres del registro?", "question").then((resp) => {
					if (resp.value) {		
					_sReceptionFrozenService.caliberSapUpdate(this.itemsCaliber, this.$fun.getUserID()).then(r => { 
						if(r.status == 200){
							this.$fun.alert("Calibers removidos", "success");
							this.loadItemsCaliber();
						}
					});
					}
				});
				
			},
			onCheckboxChange(){
				this.$emit("DevolutionByPay", this.lotReception.RfsDevolutionByPay);
			},
			onCheckboxChange2(){
				this.$emit("DiscardNotAceppted", this.lotReception.RfsDiscardNotAceppted);
			},
			calculateDiscartNotAcepptedMaq(){
				if(this.lotReception.RfsDiscardNotAceppted){
					this.lotReception.RfsWeightDiscardNotAcepptedMaq = this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate
				}else{
					this.lotReception.RfsWeightDiscardNotAcepptedMaq = 0;
				}
				console.log("RfsWeightDiscardNotAcepptedMaq",this.lotReception.RfsWeightDiscardNotAcepptedMaq);
			},

			calculateTotalKgNoAceptable() {
				let total = 0;
				for (const groupKey of Object.keys(this.newGroups)) {
					for (const item of this.newGroups[groupKey]) {
						const value = parseFloat(this.getUnacceptableKg(item));
						total += isNaN(value) ? 0 : value;
					}
				}

				// if (total > 0) this.lotReception.RfsWeigth = (this.lotReception.TotalSap.toFixed(2) - total.toFixed(2));
				if (total > 0) {
					this.lotReception.RfsWeigth = (this.RfsWeigthLocal - total).toFixed(2);					
					this.lotReception.RfsWeightDevolutionByPay = total.toFixed(2);
				}


				return total.toFixed(2);
			},

			getUnacceptableKg(j) {
				// const totalPct = parseFloat(item.RfcPercentage || 0); // Ej. 42.17
				// const noAceptablePct = parseFloat(this.getUnacceptablePercentage(item) || 0); // Ej. 42.17
				// const quantity = parseFloat(item.RfcQuantityKg || 0); // Ej. 3.21 kg

				// if (totalPct === 0) return "0.00"; // Evita división por cero

				// const result = (noAceptablePct * quantity) / totalPct;
				// item.RfcQuantityDevolutionByPayKg = result.toFixed(2);
				// item.RfcQuantityAcceptableKg = (quantity - result).toFixed(2);
				// return result.toFixed(2);
				// const id = item.DctgID;
				// const aceptablePct = parseFloat(this.acceptablePercentages[id] || 0); // Porcentaje aceptable definido por el usuario
				// const quantity = parseFloat(item.RfcQuantityKg || 0); // Peso actual del ítem
				// const netWeight = parseFloat(this.lotReception.WbbNetWeight || 0); // Peso neto total del lote

				// if (netWeight === 0) return "0.00"; // Evita división por cero

				// // Calcula los KG aceptables según el % del lote
				// const acceptableKg = (netWeight * aceptablePct) / 100;

				// // KG no aceptables = lo reportado - lo aceptable
				// let notAcceptableKg = quantity - acceptableKg;

				// if (notAcceptableKg < 0) notAcceptableKg = 0;

				// item.RfcQuantityAcceptableKg = acceptableKg.toFixed(2);
				// item.RfcQuantityDevolutionByPayKg = notAcceptableKg.toFixed(2);

				// return notAcceptableKg.toFixed(2);

				return j.RfcQuantityDevolutionByPayKg != null
				? j.RfcQuantityDevolutionByPayKg.toFixed(2)
				: '0.00';
			},
			updateNoAceptable(j) {
				// const id = item.DctgID;
				// let aceptable = parseFloat(this.acceptablePercentages[id] || 0);
				// let total = parseFloat(item.RfcPercentage || 0);

				// // Validamos que no se pase del total
				// if (aceptable > total) {
				// this.acceptablePercentages[id] = total;
				// }

				// const totalKg = this.lotReception.WbbNetWeight;
				const totalKg = (parseFloat(this.lotReception.WbbNetWeight) - parseFloat(this.lotReception.RfsWeightDevolution));
				let userPercentage = parseFloat(this.acceptablePercentages[j.DctgID]) || 0;

				// 1. Calcular el porcentaje original desde los kg
				const originalPercentage = (j.RfcQuantityKg * 100) / totalKg;

				// ✅ Validar que el usuario no supere el % máximo permitido
				if (userPercentage > originalPercentage) {
					this.acceptablePercentages[j.DctgID] = originalPercentage.toFixed(5);
					userPercentage = originalPercentage;
				}

				// 2. Calcular los kg aceptables desde el % ingresado
				const acceptableKg = parseFloat(((totalKg * userPercentage) / 100).toFixed(2));

				// 3. Calcular los kg no aceptables como diferencia
				const noAcceptableKg = parseFloat((j.RfcQuantityKg - acceptableKg).toFixed(2));

				// 4. Calcular el % no aceptable como diferencia
				const noAcceptablePercent = parseFloat((originalPercentage - userPercentage).toFixed(2));

				// 5. Asignar los valores
				j.RfcQuantityAcceptableKg = acceptableKg;
				j.RfcQuantityDevolutionByPayKg = noAcceptableKg;
				j._UnacceptablePercentage = noAcceptablePercent; // Usado por getUnacceptablePercentage si querés
			},
			getUnacceptablePercentage(j) {
				// const id = item.DctgID;
				// const total = parseFloat(item.RfcPercentage || 0);

				// // Si aún no existe el valor en el mapa, lo inicializas igual al total
				// if (!(id in this.acceptablePercentages)) {
				// 	this.$set(this.acceptablePercentages, id, total);
				// 	return 0.00;
				// }

				// const aceptable = parseFloat(this.acceptablePercentages[id] || 0);
				// const noAceptable = total - aceptable;

				// return noAceptable <= 0 ? 0.00 : noAceptable.toFixed(2);

				return j._UnacceptablePercentage != null
				? j._UnacceptablePercentage.toFixed(2)
				: '0.00';
			},	
            loadItemsCaliber(){
                // console.log("RcfID",this.lotReception);
                
                _sReceptionFrozenService
                    .GetCaliber(
                        { RcfID: this.lotReception.RcfID, TypeCultive: this.lotReception.TypeCultive },
                            this.$fun.getUserID(),
                        )
                        .then(r => {
                            var dataCaliber = r.data;
                            // console.log("Itemmmsss",r);
                            this.itemsCaliber = dataCaliber;
                            
                            if(this.itemsCaliber.length == 0)return;
                                
                            this.travelCaliber(dataCaliber);
                        });
            },
            travelCaliber(itemsCaliber){
                // console.log("items caliberrr",itemsCaliber);
                // var sum  = 0;

                //     // for (let prop in itemsCaliber) {
                //         //console.log("Descripci111111111111111",prop);
                //         this.itemsCaliber.map((i) => {

                //             i.RcfID = this.lotReception.RcfID;
                //             i.SecStatus = 1
                //             i.RfsID= this.lotReception.RfsID || 0;
                //             i.UsrCreateID = this.$fun.getUserID();
                //             i.UsrUpdateID = i.RfcID ? this.$fun.getUserID(): 0;
                //             if(i.RfcQuantityKg == ''){
                //                 i.RfcQuantityKg = 0
                //             }
                //             sum += parseFloat(i.RfcQuantityKg == null ? 0 : i.RfcQuantityKg)
                //             const total = this.lotReception.WbbNetWeight || 0;
				// 			if (total > 0 && i.RfcQuantityKg > 0 ) {
				// 				const percent = (i.RfcQuantityKg * 100) / total;
				// 				i.RfcPercentage = percent.toFixed(2);
				// 			} else {
				// 				i.RfcPercentage = 0;
				// 			}
				// 			const id = i.DctgID;
				// 			if(total > 0 && i.RfcQuantityAcceptableKg > 0){
				// 				const percentAcceptable = ((i.RfcQuantityAcceptableKg * 100) / total).toFixed(2);
				// 				if (!(id in this.acceptablePercentages)) {
				// 					this.$set(this.acceptablePercentages, id, percentAcceptable);
				// 					return 0.00;
				// 				}
				// 			}    
                //         });
                //         let description = {};
                //         description = _.groupBy(this.itemsCaliber, "CtgDescription");
                //         //console.log("Descripci111111111111111",prop);
                //         // console.log("Descripcionnnnn",description);
                        
                //         for (const atributo in description) {
                //             description[atributo].forEach(element => {
                //                 console.log("Caliberrr11232323",element);
                //                 this.listItemsCalibers.push(element);
                //             });
                //         }
                        
                //         this.newGroups = description;
                //     // console.log("nuevo Group",this.newGroups);
                //     this.$emit("itemsCalibers", this.listItemsCalibers);
                //     // }	
				this.listItemsCalibers = [];
				let sum = 0;
				// const total = this.lotReception.WbbNetWeight || 0;
				const total = (parseFloat(this.lotReception.WbbNetWeight) - parseFloat(this.lotReception.RfsWeightDevolution));

				this.removedCaliber = this.itemsCaliber.some((i) => i.RfcID > 0);
				
				this.itemsCaliber.map((i) => {
					i.RcfID = this.lotReception.RcfID;
					i.SecStatus = 1;
					i.RfsID = this.lotReception.RfsID || 0;
					i.UsrCreateID = this.$fun.getUserID();
					i.UsrUpdateID = i.RfcID ? this.$fun.getUserID() : 0;

					// Validar cantidad
					i.RfcQuantityKg = parseFloat(i.RfcQuantityKg) || 0;

					sum += parseFloat(i.RfcQuantityKg == null ? 0 : i.RfcQuantityKg);

					// Calcular % original
					if (total > 0 && i.RfcQuantityKg > 0) {
						const percent = (i.RfcQuantityKg * 100) / total;
						i.RfcPercentage = parseFloat(percent.toFixed(5));
					} else {
						i.RfcPercentage = 0.00;
					}

					const id = i.DctgID;

					// Caso cuando ya fue registrado (RfcID > 0)
					if (total > 0 && i.RfcID > 0) {
						if (i.RfcQuantityAcceptableKg > 0) {
							// Recalcular % aceptable desde los kg aceptables ya guardados
							const percentAcceptable = (i.RfcQuantityAcceptableKg * 100) / total;
							this.$set(this.acceptablePercentages, id, parseFloat(percentAcceptable.toFixed(5)));
						}

						// Calcular % no aceptable como diferencia
						const percentNoAcceptable = i.RfcPercentage - (this.acceptablePercentages[id] || 0);
						i._UnacceptablePercentage = parseFloat(percentNoAcceptable.toFixed(5));

						// Calcular kg no aceptables como diferencia
						i.RfcQuantityDevolutionByPayKg = parseFloat((i.RfcQuantityKg - i.RfcQuantityAcceptableKg).toFixed(5));
					}

					console.log("i.RfcPercentageeeee",i.RfcPercentage);
					console.log("i.RfcPercentageeeee2222",i);
					// Caso nuevo (no registrado)
					if (!i.RfcID || i.RfcID === 0) {
					// Aceptable = 100% del porcentaje original
						console.log("i.RfcPercentageeeee",i.RfcPercentage);
						this.$set(this.acceptablePercentages, id, i.RfcPercentage);
						i.RfcQuantityAcceptableKg = i.RfcQuantityKg != null ? parseFloat(i.RfcQuantityKg.toFixed(2)) : 0.00;
						i.RfcQuantityDevolutionByPayKg = 0.00;
						i._UnacceptablePercentage = 0.00;
					}
				});

				// Agrupar por descripción
				const description = _.groupBy(this.itemsCaliber, "CtgDescription");

				for (const atributo in description) {
					description[atributo].forEach((element) => {
					this.listItemsCalibers.push(element);
					});
				}

				this.newGroups = description;
				this.$emit("itemsCalibers", this.listItemsCalibers);		          
            },
            getPrice(j) {
                if(this.loadPrice.some((x) => x.CtgID === j[0].CtgID))
                    return this.loadPrice.find((x) => x.CtgID === j[0].CtgID).CfpAmount; 
                else
                    return 0;
            },
            getColor(j) {
                return this.loadPrice.some((x) => x.CtgID === j[0].CtgID) ? 'success' : '#b7b7b7';
            },
			getCalcule() {
				this.getCalculeInner();
				this.calculateDiscartNotAcepptedMaq();
				this.getCaluleDiscartMaq();
				this.getCaluleBolilloMaq();
			},
			getCalculeInner() {

				 
				this.lotReception.infRefDifference = (this.lotReception.RcfWeightGuide - this.lotReception.WbbNetWeight).toFixed(2);
				this.lotReception.infRefDifferencePercentage = ((this.lotReception.infRefDifference/this.lotReception.RcfWeightGuide)*100).toFixed(2);

				//samir
				// this.lotReception.discartPercentage = 
				console.log({ 
					AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart,
					discartPercentage: this.lotReception.discartPercentage
				 })

				//  if( !this.AcceptedToleranceInputDiscart ) return; 

				if ( parseFloat(this.AcceptedToleranceInputDiscart) >=  parseFloat(this.lotReception.discartPercentage) ) {
					this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = parseFloat(this.lotReception.discartPercentage);
					// this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = 0;
				//this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = (this.lotReception.RcfWeightGuide*(this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput/100)).toFixed(2);
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = this.lotReception.discart;
					this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = 0;
					this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate =0;

					console.log({ if : 1 })

					this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.discartPercentage;//SAMIR
					//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
				} 
				
				if ( parseFloat(this.AcceptedToleranceInputDiscart) < parseFloat(this.lotReception.discartPercentage) ){
					this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = parseFloat(this.AcceptedToleranceInputDiscart);
					
					let weightDevolution = isNaN(this.lotReception.RfsWeightDevolution) ? 0 : parseFloat(this.lotReception.RfsWeightDevolution);
					let baseWeight = parseFloat(this.lotReception.WbbNetWeight) - weightDevolution;

					this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = (baseWeight * (this.AcceptedToleranceInputDiscart/100)).toFixed(2);
					this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (this.lotReception.discartPercentage - this.AcceptedToleranceInputDiscart).toFixed(2);
					this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = (this.lotReception.discart - this.lotReception.tolWeiDisSelToleranceAcceptedCalculate).toFixed(2);

					console.log({ if : 2 })
				
					this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
					//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
				}
				// this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = this.AcceptedToleranceInputDiscart;
				
				// this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = (this.lotReception.WbbNetWeight*(this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput/100)).toFixed(2);
				// this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (this.lotReception.discartPercentage -this.AcceptedToleranceInputDiscart).toFixed(2);


				// this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = (this.lotReception.discart - this.lotReception.tolWeiDisSelToleranceAcceptedCalculate).toFixed(2);

				this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted = (parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate));
				
				this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAcceptedPercentage = 
				this.lotReception.RcfWeightGuide > 0
				? (parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate/this.lotReception.RcfWeightGuide)*100).toFixed(2)
				: 0
				this.lotReception.DisTotWeightPay = (this.lotReception.WbbNetWeight - this.lotReception.RfsWeightDevolution - this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted);
				this.lotReception.DisTotWeightPayPercentage = this.lotReception.RcfWeightGuide > 0
				? ((this.lotReception.DisTotWeightPay/this.lotReception.RcfWeightGuide)*100).toFixed(2)
				: 0

				this.lotReception.RfsWeightDiscart = (parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate)).toFixed(2);
				this.lotReception.RfsWeigth = (parseFloat(this.lotReception.DisTotWeightPay) - parseFloat(this.lotReception.RfsWeightDiscart) - parseFloat(this.lotReception.RfsWeightBolillo)).toFixed(2);


				//				
				// this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput; 
				this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;
				// if(this.lotReception.RfsWeightBolilloc == 0){
					this.lotReception.RfsWeightBolilloc = this.lotReception.RfsWeightBolillo;
				// }
				this.RfsWeightDiscartLocal = this.lotReception.RfsWeightDiscart;
				this.getCaluleDiscartMaq();
				this.calculateDiscartNotAcepptedMaq();
				this.getCaluleBolilloMaq();
			},

			getCaluleBolilloMaq(){
				let valor = this.lotReception.RfsWeightBolillo;
				let porcentaje = this.AcceptedBolilloMaq;

				this.lotReception.RfsWeightBolilloMaq = (valor * (porcentaje / 100)).toFixed(2);
				this.lotReception.RfsBolilloMaqPercentage = this.AcceptedBolilloMaq;
				console.log("porcentajeBolilloMaq",porcentaje);
				if(this.lotReception.RfsWeightBolilloMaq > 0 && this.lotReception.RfsWeightBolilloMaq != null && this.lotReception.RfsWeightBolilloMaq != undefined){
					this.lotReception.PorceBolilloMaq = ((parseFloat(this.lotReception.RfsWeightBolilloMaq)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
					this.lotReception.RfsWeightBolilloc = (this.lotReception.RfsWeightBolillo - this.lotReception.RfsWeightBolilloMaq).toFixed(2) ;
					this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolilloc)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
				}
				else{
					this.lotReception.PorceBolilloMaq = 0;
					this.lotReception.RfsWeightBolilloc = this.lotReception.RfsWeightBolillo;
					this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolillo)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
				}
				this.lotReception.TotalSap = parseFloat(this.lotReception.RfsWeigth) + parseFloat(this.lotReception.RfsWeightDiscart) + parseFloat(this.lotReception.RfsWeightBolillo)+ parseFloat(this.lotReception.RfsWeightDiscartMaq) + parseFloat(this.lotReception.RfsWeightDiscardNotAcepptedMaq);
				console.log("porcentajeBolilloMaq",this.lotReception.PorceBolilloMaq)
			},
			getCaluleDiscartMaq(){			
				let valor = this.RfsWeightDiscartLocal;
				let porcentaje = this.AcceptedDiscartMaq;
				// console.log("DiscarteLocal",this.RfsWeightDiscartLocal);
				this.lotReception.RfsDiscartMaqPercentage = this.AcceptedDiscartMaq;
				this.lotReception.RfsWeightDiscartMaq = (valor * (porcentaje / 100)).toFixed(2);
				console.log("porcentajeDiscartMaq1",porcentaje);
				console.log("RfsWeightDiscartMaq",this.lotReception.RfsWeightDiscartMaq);
				if(this.lotReception.RfsWeightDiscartMaq > 0 && this.lotReception.RfsWeightDiscartMaq != null && this.lotReception.RfsWeightDiscartMaq != undefined){
					this.lotReception.PorceDiscartMaq = ((parseFloat(this.lotReception.RfsWeightDiscartMaq)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
					this.lotReception.RfsWeightDiscart = (this.RfsWeightDiscartLocal - this.lotReception.RfsWeightDiscartMaq).toFixed(2);				
				}
				else{
					this.lotReception.PorceDiscartMaq = 0;
					this.lotReception.RfsWeightDiscart = this.RfsWeightDiscartLocal;				
				}
				console.log("porcentajeDiscartMaq2",this.lotReception.PorceDiscartMaq);
			}
		},
		computed: {
			finalweightacceptable() {
			const pesoOriginal = this.RfsWeigthLocal || 0;
			const totalKgNoAceptable = this.calculateTotalKgNoAceptable() || 0;
			return (pesoOriginal - totalKgNoAceptable).toFixed(2);
			}
		},
		created () {
            this.loadItemsCaliber();
		},
		mounted(){
			this.AcceptedToleranceInput = 0;
			this.AcceptedToleranceInputDiscart = this.lotReception.AcceptedToleranceInputDiscart ?? 0;
			
			this.AcceptedDiscartMaq = this.lotReception.RfsDiscartMaqPercentage;
			// this.AcceptedDiscartMaq = (this.lotReception.TypeCultive == 3) 
			// 	? ((!this.lotReception.RfsDiscartMaqPercentage || this.lotReception.RfsDiscartMaqPercentage == 0) ? 100 : this.lotReception.RfsDiscartMaqPercentage) 
			// 	: 0;
			this.getCaluleDiscartMaq();
			this.AcceptedBolilloMaq = this.lotReception.RfsBolilloMaqPercentage;
			
			this.getCalcule();
			this.RfsWeigthLocal = this.lotReception.RfsWeigth;
			this.labelCheckBox= this.lotReception.RfsDevolutionByPay ? "Si" : "No";
			this.labelCheckBox2= this.lotReception.RfsDiscardNotAceppted ? "Si" : "No";
			
			console.log("RfsDiscardNotAceppted",this.lotReception.RfsDiscardNotAceppted)
		}
		
	}
</script>
